document.addEventListener("DOMContentLoaded", function () {
  
  menuHoverEvent();
  subscriptionForms();
  productMediaGallery();
  imageWithTextSection();
  imageSliderWithTextInfoSection();
  slideShowSliderSection();
  relatedBlogSlider();

  
  //outside click event
  document.onclick = function(e){
    //for address popup close event
    if(e.target.classList.contains('edit_address-overlay')){
      if(document.querySelector('.popup-active')){
        document.querySelector('.popup-active').classList.remove('popup-active');
        document.body.classList.remove('active-address-popup');
      }
    }

    //for product course dropdown close event
    if(e.target.closest('body')?.querySelector('.course-set-menu.active') && !e.target.closest('[data-category-item-list]') && !e.target.closest('.course-list-menu')){
      document.querySelector('.course-set-menu.active').classList.remove('active');
    }
  };

  //product course dropdown event
  let course_dropdown = document.querySelector('[data-category-item-list]');
  if(course_dropdown){
    course_dropdown.addEventListener('click',(e) => {
      e.preventDefault();
      e.target.closest('.course-set-menu').classList.toggle('active');
    });
  }

  //customer account page tab
  let accountTabs = document.querySelectorAll('.template-account [data-account-tabs] [data-tab]');
  if(accountTabs.length){
    // add active class to active tab based on url search param
    setTimeout(() => {
      let serachParamValue = getSeachQueryString('tab');
      if(serachParamValue){
        document.querySelector(`.template-account [data-account-tabs] [data-tab="${serachParamValue}"]`).click();  
      }
    },100);
  
    accountTabs.forEach(list => {
      list.addEventListener('click',(e) => {
        e.preventDefault();
        let currentList = e.target.closest('[data-tab]');
        let currentTabName = currentList.dataset.tab;
        e.target.closest('.account').querySelectorAll(`[data-account-tabs] [data-tab]`).forEach(li => li.classList.remove('active'));
        currentList.classList.add('active');
        if(e.target.closest('.account').querySelectorAll(`[data-account-detailes-element] [data-tab]`).length){
          e.target.closest('.account').querySelectorAll(`[data-account-detailes-element] [data-tab]`).forEach(tab => tab.classList.remove('active'));
          e.target.closest('.account').querySelector(`[data-account-detailes-element] [data-tab="${currentTabName}"]`).classList.add('active');  
        }
        //add serach param to url
        if ('URLSearchParams' in window) {
          const url = new URL(window.location);
          url.searchParams.set("tab", currentTabName);
          history.pushState(null, '', url);
        }
      });
    });
  }

  //address popup close event
  let addressPopupCloseBtn = document.querySelectorAll('.template-addresses [data-address-popup-close]');
  if(addressPopupCloseBtn.length){
    addressPopupCloseBtn.forEach(btn => {
      btn.addEventListener('click',(e) => {
        e.preventDefault();
        e.target.closest('[data-address]').querySelector('button[type="reset"]').click();
      });
    });
  }

  //about-us page smooth scroll link
  let cardImageLink = document.querySelectorAll('.template-suffix-about-us .multicolumn-college-section .grid__item .multicolumn-card-image-link');
  if(cardImageLink.length){
    cardImageLink.forEach(link => {
      link.addEventListener('click',(e) => {
        if(link.getAttribute('href').includes('#')){
          e.preventDefault();
          let linkRef = link.getAttribute('href').replace('#','');
          let element = document.querySelector(`div[id="${linkRef}"]`);
          if(element){
            let headerOffset = 75;
            let offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - headerOffset;
            window.scrollTo({
             top: offsetPosition,
             behavior: "smooth"
            });
          }
        }        
      });
    });
  }

  
  //card-product-list readmore description
  let prodReadmoreEle = document.querySelectorAll('.featured-products-list-section [data-toggle-readmore]');
  if(prodReadmoreEle.length){
    prodReadmoreEle.forEach(ele => {
      ele.addEventListener('click',(e) => {
        e.preventDefault();
        const target = e.target;
        target.classList.toggle('open');
        const closestDesc = target.closest('[data-readmore-wrap]')?.querySelector('.readmore-desc');
        if(closestDesc){
          const maxHeight = closestDesc.scrollHeight;
          if(target.classList.contains('open')){
            closestDesc.style.maxHeight = `${maxHeight}px`;
          }else{
            closestDesc.style.maxHeight = "0px";
          }
        }
      });
    });
  }

  //card-product-list buy-individual-products description
  let prodBuyProductsEle = document.querySelectorAll('.featured-products-list-section [data-toggle-buy-products]');
  if (prodBuyProductsEle.length) {
    prodBuyProductsEle.forEach(ele => {
      ele.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.target;
        const wrap = target.closest('[data-buy-products-wrap]');
        const desc = wrap?.querySelector('.buy-products-desc');

        if (desc) {
          const isOpen = target.classList.toggle('open');
          if (isOpen) {
            desc.classList.add('show');
            desc.style.maxHeight = `${desc.scrollHeight}px`;
          } else {
            desc.style.maxHeight = '0px';
            desc.classList.remove('show');
          }
        }
      });
    });
  }
  
  //mix-match collection template complementry prod deatils description slide-up/down
  let cmplProdDetailesEle = document.querySelectorAll('.template-suffix-mix-and-match-bundle [data-toggle-details]');
  if(cmplProdDetailesEle.length){
    cmplProdDetailesEle.forEach(ele => {
      ele.addEventListener('click',(e) => {
        e.preventDefault();
        const target = e.target;
        target.classList.toggle('open');
        const closestDesc = target.closest('[data-card-desc]')?.querySelector('.complementary-desc');
        if(closestDesc){
          const maxHeight = closestDesc.scrollHeight;
          if(target.classList.contains('open')){
            closestDesc.style.maxHeight = `${maxHeight}px`;
          }else{
            closestDesc.style.maxHeight = "0px";
          }
        }
      });
    });
  }
  
  enhanceToggleA11y();
  enhanceLinkPurposeA11y();
});
 
function enhanceToggleA11y() {
  const configs = [
    { selector: '.featured-products-list-section [data-toggle-readmore]', wrap: '[data-readmore-wrap]', panel: '.readmore-desc' },
    { selector: '.featured-products-list-section [data-toggle-buy-products]', wrap: '[data-buy-products-wrap]', panel: '.buy-products-desc' },
    { selector: '.template-suffix-mix-and-match-bundle [data-toggle-details]', wrap: '[data-card-desc]', panel: '.complementary-desc' }
  ];
  let uid = 0;

  configs.forEach(cfg => {
    document.querySelectorAll(cfg.selector).forEach(el => {
      if (el.dataset.a11yBound) return;
      if (el.tagName !== 'BUTTON' && el.hasAttribute('role')) return;
      el.dataset.a11yBound = 'true';

      if (el.tagName !== 'BUTTON') {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            el.click();
          }
        });
      }

      const panel = el.closest(cfg.wrap)?.querySelector(cfg.panel);
      if (panel) {
        if (!panel.id) panel.id = 'toggle-panel-' + (++uid);
        el.setAttribute('aria-controls', panel.id);
      }

      const sync = () => {
        const isOpen = el.classList.contains('open');
        el.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (panel) panel.inert = !isOpen;
      };
      sync();
      el.addEventListener('click', sync);

      if (el.matches('[data-toggle-buy-products], [data-toggle-readmore]')) {
        const card = el.closest('.card-wrapper, .grid__item, .product-card, li');
        const title = card?.querySelector('.card__heading, h2, h3, h4')?.textContent.replace(/\s+/g, ' ').trim();
        if (title) el.setAttribute('aria-label', el.textContent.trim() + ': ' + title);
      }
    });
  });
}
// Accessibility: give repeated generic links ("View Sample", "Learn More"...) a unique name with their product
function enhanceLinkPurposeA11y() {
  const genericTexts = ['view sample', 'sample pages', 'view full details', 'learn more'];
  const headingSel = '.card__heading, .product__title, h2, h3, h4, h5';

  document.querySelectorAll('a').forEach(a => {
    if (a.dataset.purposeBound || a.hasAttribute('aria-label')) return;
    if (a.closest('#dk-learn-more-round-up, .dk-backend-static')) return; // DailyKarma: vendor-owned

    const text = a.textContent.replace(/\s+/g, ' ').trim();
    if (!genericTexts.includes(text.toLowerCase())) return;

    let node = a.parentElement;
    let title = '';
    for (let i = 0; i < 6 && node && node !== document.body; i++) {
      const h = node.querySelector(headingSel);
      if (h && !h.contains(a)) {
        title = h.textContent.replace(/\s+/g, ' ').trim();
        break;
      }
      node = node.parentElement;
    }
    if (!title) return;

    let label = text + ': ' + title;
    if (a.target === '_blank') label += ' (opens in a new tab)';
    a.setAttribute('aria-label', label);
    a.dataset.purposeBound = 'true';
  });
    document.querySelectorAll('a[href*="/pages/free-downloads-"]').forEach(a => {
    if (a.hasAttribute('aria-label')) return;
    const text = a.textContent.replace(/\s+/g, ' ').trim();
    if (!/^level\s+\S+$/i.test(text)) return;
    const href = a.getAttribute('href').toLowerCase();
    let subject = '';
    if (href.includes('language-arts')) subject = 'Language Arts';
    else if (href.includes('math') || href.includes('algebra')) subject = 'Math';
    if (!subject) return;
    a.setAttribute('aria-label', `${text}: Free ${subject} downloads`);
  });
}
function menuHoverEvent() {
  const headerMenuLists = document.querySelectorAll('header-menu > details');
  if(headerMenuLists.length){
    headerMenuLists.forEach(list => {
      //on hover
      list.addEventListener("mouseenter", (e) => {
        e.target.setAttribute('open','');
        if(e.target.querySelector('summary')){
          e.target.querySelector('summary').setAttribute('aria-expanded','true');
        }
      });
      //on hover out
      list.addEventListener("mouseleave", (e) => {
        headerMenuLists.forEach(list => {
          list.removeAttribute('open');
          if(list.querySelector('summary')){
            list.querySelector('summary').setAttribute('aria-expanded','false');
          }
        });
      });
    });
  }
}

function subscriptionForms() {
  const sectionEle = document.querySelectorAll(".shopify-section.subscription-forms, .shopify-section.free-download-form");
  if (sectionEle.length) {
    sectionEle.forEach((section) => {
      const forms = section.querySelectorAll("form.custom_klaviyo_form");
      if (forms.length) {
        forms.forEach((form, formIndex) => {
          const emailInput = form.querySelector('[name="email"]');
          const errorEl = emailInput?.parentElement.querySelector(".form_error_message");
          const confirmEl = form.closest('[data-form-content]')?.querySelector('.form_confirmation_msg');

          if (errorEl) {
            if (!errorEl.id) errorEl.id = 'form-error-' + (section.id || 'section') + '-' + formIndex;
            errorEl.setAttribute('role', 'alert');
            emailInput.setAttribute('aria-describedby', errorEl.id);
          }
          if (confirmEl) {
            confirmEl.setAttribute('role', 'status');
          }
          const groupHeading = form.closest('[data-form-content]')?.querySelector('h1, h2, h3, h4, h5, h6, .title');
          if (groupHeading && !form.hasAttribute('aria-labelledby')) {
            if (!groupHeading.id) groupHeading.id = 'form-heading-' + (section.id || 'section') + '-' + formIndex;
            form.setAttribute('aria-labelledby', groupHeading.id);
          }
          form.addEventListener("submit", function (e) {
            e.preventDefault();

            if (errorEl) {
              errorEl.textContent = ``;
              emailInput.removeAttribute('aria-invalid');
            }

            let data = new FormData(form);
            let serializeData = serialize(data);
            if (validateEmail(serializeData.email)) {
              console.log("email validated");
              submitData(serializeData, form);
              form.reset();
            } else {
              if (errorEl) {
                errorEl.textContent = `Enter a valid email address`;
                emailInput.setAttribute('aria-invalid', 'true');
                emailInput.focus();
              }
            }
          });
        });
      }
    });
  }
}

function validateEmail(value) {
  let mailRegularExpression = /^[a-zA-Z0-9._#%+\-!$&'*\/=?^`{|}~]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return mailRegularExpression.test(value);
}


function submitData(values, form) {
  const options = {
    method: "POST",
    headers: { revision: "2023-10-15", "content-type": "application/json" },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              id: "",
              attributes: {
                email: values.email,
                first_name: values.firstName
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: values.listId
            }
          }
        }
      }
    })
  };
  //console.log('options >>',options);
  fetch("https://a.klaviyo.com/client/subscriptions/?company_id=WQJ4FS",options)
  .then((response) => {
    if (response.status == 202) {
      console.log("success submitting -->",response);
      if(form.closest('[data-form-content]').querySelector('.form_confirmation_msg')){
        form.closest('[data-form-content]').querySelector('.form_confirmation_msg').classList.remove('hidden');
        form.closest('.form-content').classList.add('hidden');

        //download file if have
        if(form.closest('[data-form-content]').querySelector('input[name="download"]')){
          console.log("Started download file")
          setTimeout(() => {
            window.open(values.download, '_blank', 'noopener, noreferrer');
          });
          if (typeof gtag == 'function') {
            gtag('event', 'free_download');                        
          }
        }
        
      }
    } else {
      console.log("Response Status: " + response.status);
    }
  })
  .catch((err) => console.error(err));
}

function serialize(data) {
  let obj = {};
  for (let [key, value] of data) {
    if (obj[key] !== undefined) {
      if (!Array.isArray(obj[key])) {
        obj[key] = [obj[key]];
      }
      obj[key].push(value);
    } else {
      obj[key] = value;
    }
  }
  return obj;
}

function getSeachQueryString(key) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
}

function productMediaGallery() {
  let meidaGallerySwiper = document.querySelector('[data-media-gallery-carousel] [data-gallery-slider]');
  if(meidaGallerySwiper){
    gallerySwiperInit = new Swiper(meidaGallerySwiper, {
      effect: 'fade',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      pagination: {
        el: "[data-gallery-slider] .swiper-pagination",
        clickable: true,
      },
      on: {
        // Pause any playing video when the slide changes.
        // Videos never start on their own; shoppers press play.
        transitionStart: function(){
          const allVideos = [...meidaGallerySwiper.querySelectorAll('video, iframe')];
          if(allVideos.length) window.pauseAllMedia();
        }
      }
    });
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    addGalleryPauseButton(meidaGallerySwiper, gallerySwiperInit, reduceMotion);
  }
}

// Accessibility: visible, keyboard-operable pause/play for the PDP gallery autoplay (WCAG 2.2.2)
function addGalleryPauseButton(container, swiper, startPaused) {
  if (!swiper || !swiper.autoplay || container.querySelector('.gallery-autoplay-toggle')) return;

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'gallery-autoplay-toggle';

  const pauseIcon = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="16" height="16"><rect x="6" y="5" width="4" height="14" fill="currentColor"/><rect x="14" y="5" width="4" height="14" fill="currentColor"/></svg>';
  const playIcon = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="16" height="16"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';

  let paused = !!startPaused;
  const render = () => {
    btn.setAttribute('aria-label', paused ? 'Play image slideshow' : 'Pause image slideshow');
    btn.innerHTML = paused ? playIcon : pauseIcon;
  };

  if (paused) swiper.autoplay.stop();
  render();

  btn.addEventListener('click', () => {
    paused = !paused;
    paused ? swiper.autoplay.stop() : swiper.autoplay.start();
    render();
  });

  container.appendChild(btn);
}

function toggleAccordion(element) {
  const content = element.closest('.content-container')?.querySelector(".accordion__content");
  if(content){
    element.closest('.content-container').classList.toggle('open');
    if(element.closest('.content-container').classList.contains('open')){
      content.style.maxHeight = content.scrollHeight + "px";
    }else{
      content.style.maxHeight = "0px";
    }
  }
}

function imageWithTextSection() {
  let imagesEle = document.querySelectorAll('.image-slider-with-text-section [data-image-slider]');
  if(imagesEle.length){
    imagesEle.forEach(imgsSlide => {
      let swiper = new Swiper(imgsSlide, {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: imgsSlide.querySelector(".swiper-pagination"),
          type: "fraction"
        },
        navigation: {
          nextEl: imgsSlide.querySelector(".swiper-button-next"),
          prevEl: imgsSlide.querySelector(".swiper-button-prev")
        }
      });

      if(imgsSlide.querySelector('[data-play-pause]')){
        imgsSlide.querySelector('[data-play-pause]').addEventListener('click',(e) => {
          e.preventDefault();
          if(e.target.closest('[data-play-pause]').classList.contains('play')){
            e.target.closest('[data-play-pause]').classList.add('pause');
            e.target.closest('[data-play-pause]').classList.remove('play');
            if(swiper) swiper.autoplay.stop();
          }else{
            e.target.closest('[data-play-pause]').classList.add('play');
            e.target.closest('[data-play-pause]').classList.remove('pause');
            if(swiper) swiper.autoplay.start();
          }
        });
      }
    });
  }
}

function imageSliderWithTextInfoSection() {
  let imagesEle = document.querySelectorAll('.image-slider-with-text-info-section [data-image-slider]');
  if(imagesEle.length){
    imagesEle.forEach(imgsSlide => {
      let swiper = new Swiper(imgsSlide, {
        slidesPerView: 1,
        pagination: {
          el: imgsSlide.querySelector(".swiper-pagination"),
          clickable: true
        },
      });
    });
  }
}

function slideShowSliderSection() {
  let slideEle = document.querySelectorAll('.slideshow-slider-section [data-slideshow-slider]');
  if(slideEle.length){
    slideEle.forEach(slide => {
      let swiper = new Swiper(slide, {
        slidesPerView: 1,
        effect: 'fade',
        navigation: {
          nextEl: slide.querySelector(".swiper-button-next"),
          prevEl: slide.querySelector(".swiper-button-prev")
        }
      });
    });
  }
}


function relatedBlogSlider() {
  let slideEle = document.querySelectorAll('.related-blog-post-section [data-related-blog-slider]');
  if(slideEle.length){
    slideEle.forEach(slide => {
      let swiper = new Swiper(slide, {
        slidesPerView: 1.3,
        spaceBetween: 20,
        navigation: {
          nextEl: slide.querySelector(".swiper-button-next"),
          prevEl: slide.querySelector(".swiper-button-prev")
        },
        breakpoints: {
          750: {
            slidesPerView: 2
          },
          990: {
            slidesPerView: 3
          },
        }
      });
    });
  }
}


// This will only render in the theme editor
if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){
      
      const productMediaGalleryEle = event.target.closest('.main-product-section') || null;
      if(productMediaGalleryEle && productMediaGalleryEle.querySelector('[data-media-gallery-carousel]')){
        productMediaGallery();
      }

      const slideShowSliderEle = event.target.closest('.slideshow-slider-section') || null;
      if(slideShowSliderEle && slideShowSliderEle.querySelector('[data-slideshow-slider]')){
        slideShowSliderSection();
      }

      const relatedBlogSliderEle = event.target.closest('.related-blog-post-section') || null;
      if(relatedBlogSliderEle && relatedBlogSliderEle.querySelector('[data-related-blog-slider]')){
        relatedBlogSlider();
      }

      const imageSliderWithTextInfoSectionEle = event.target.closest('.image-slider-with-text-info-section') || null;
      if(imageSliderWithTextInfoSectionEle && imageSliderWithTextInfoSectionEle.querySelector('[data-image-slider]')){
        imageSliderWithTextInfoSection();
      }
      
    });
  });
}
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// Remove Free Shipping Banners for ClassWallet Users
function removeBannersCW() {
  let cwVars = sessionStorage.getItem('classwallet:vars:json');
  if(cwVars) {
    // This is a ClassWallet session--Remove banners
    const freeShipBanners = document.querySelectorAll('.announcement-bar, .footer-cart-banner-box, .dk-round-up-static');
    freeShipBanners.forEach((elem) => {
      elem.remove();
    });
  }
}
removeBannersCW();

// Style DK on complementary card
function styleDKWidget() {
    const dkWidget = document.querySelectorAll('.dk-backend-static .dk-backend-wrapper');
    console.log(dkWidget);
    dkWidget.forEach((elem) => {
      elem.style.display = 'none';
    });
  }
window.addEventListener("load", (event) => {
  // This code will only run when the page has finished loading
  console.log('The website is fully loaded!');
  styleDKWidget();
});